import {
  Table,
  Button,
  Modal,
  Space,
  Form,
  Input,
  Checkbox,
  Switch,
  message,
  InputNumber,
  Select,
  Tabs,
  Tag,
  Col,
  Row,
} from "antd";
import { CheckOutlined, CloseOutlined, PlusOutlined } from "@ant-design/icons";

import React, { useEffect, useState } from "react";
import { getDirectusClient } from "../../lib/directus";
import Layouts from "../../components/Layouts";
import { createItem, deleteItem, readItems, updateItem } from "@directus/sdk";
import { useSelector } from "react-redux";
import validarpermiso from '../../lib/utils';

const { Option } = Select;
const Groups = () => {
  const [filter, setFilter] = useState([]);
  const [hasCode, setHasCode] = useState(false);
  const [Code, setCode] = useState(false);

  const [form] = Form.useForm();

  const handleCheckboxChange = (e) => {
    setHasCode(e.target.checked);
  };

  const handleCheckbox = (e) => {
    setCode(e.target.checked);
  };

  const [data, setData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ModalOpen, setModalOpen] = useState(false);
  const [OpenEdit, setOpenEdit] = useState(false);
  const [groupselect, setGroupselect] = useState({});
  const showModal = () => {
    setIsModalOpen(true);
  };
  const Modalopen = () => {
    setModalOpen(true);
  };
  const openEdit = () => {
    setOpenEdit(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setModalOpen(false);
    setOpenEdit(false);
  };

  //Get
  const GetGroups = async () => {
    const directus = await getDirectusClient();
    await directus
      .request(
        readItems("grupos", {
          fields: "*",
          limit: -1,
        })
      )
      .then((datos) => {
        setData(datos);
      });
  };

  //Post
  const onFinish = async (values) => {
    console.log(values);
    const directus = await getDirectusClient();
    const res = await directus.request(
      createItem("grupos", {
        nombre: values.nombre,
        codebar: values.codebar,
        iccid: values.iccid,
        codebarmax: values.codebarmax,
        codebarmin: values.codebarmin,
        estado: values.estado,
        iccidmin: values.iccidmin,
        iccidmax: values.iccidmax,
        impuesto: values.impuesto,
        afectainventario: values.afectainventario,
      })
    );

    if (res.id > 0) {
      message.success("Grupo creado");
      GetGroups();
    } else {
      message.error("Upss!!, algo salio mal :(");
    }
  };

  //Delete
  const DeleteGroup = async (id) => {
    const directus = await getDirectusClient();
    Modal.confirm({
      title: "Confirmar",

      content: "Desea eliminar este grupo?",
      okText: "Eliminar",
      cancelText: "Calcelar",
      onOk: async () => {
        await directus.request(deleteItem("grupos", id));
        GetGroups();
      },
    });
  };

  //Put

  useEffect(() => {
    GetGroups();
  }, []);

  const permisos = useSelector((state) => state.permisos);
  const userdata = useSelector((state) => state.userdata);

  const columns = [
    {
      title: "Name",
      dataIndex: "nombre",
      key: "nombre",
    },
    {
      title: "Serial",
      dataIndex: "codebar",
      key: "codebar",
      render: (_, record) => {
        console.log(record.codebar);
        return record.codebar ? (
          <Tag color="green">Si</Tag>
        ) : (
          <Tag color="red">No</Tag>
        );
      },
    },
    {
      title: "Serial max",
      dataIndex: "codebarmax",
      key: "codebarmax",
    },
    {
      title: "Serial min",
      dataIndex: "codebarmin",
      key: "codebarmin",
    },
    {
      title: "Iccid",
      dataIndex: "iccid",
      key: "iccid",
      render: (_, record) => {
        console.log(record.iccid);
        return record.iccid ? (
          <Tag color="green">Si</Tag>
        ) : (
          <Tag color="red">No</Tag>
        );
      },
    },
    {
      title: "Iccidmax",
      dataIndex: "iccidmax",
    },
    {
      title: "Iccidmin",
      dataIndex: "iccidmin",
    },
    {
      title: "Impuesto",
      dataIndex: "impuesto",
    },
    {
      title: "Estado",
      dataIndex: "estado",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          {validarpermiso("grupos", "update", permisos) && (
            <Button
              type="link"
              onClick={() => {
                console.log(record);
                setOpenEdit(true);
                setFilter(record);
                form.setFieldsValue({ nombre: record.nombre });
                form.setFieldsValue({ impuesto: record.impuesto });
                setHasCode(record.codebar);
                setCode(record.iccid);
                form.setFieldsValue({ codebar: record.codebar });
                form.setFieldsValue({ codebarmax: record.codebarmax });
                form.setFieldsValue({ codebarmin: record.codebarmin });
                form.setFieldsValue({ iccid: record.iccid });
                form.setFieldsValue({ iccidmax: record.iccidmax });
                form.setFieldsValue({ iccidmin: record.iccidmin });
                form.setFieldsValue({ estado: record.estado });
                form.setFieldsValue({
                  afectainventario: record.afectainventario,
                });
              }}
            >
              Edit
            </Button>
          )}
          <Button
            type="link"
            onClick={() => {
              showModal();
              setGroupselect(record);
              console.log(record);
            }}
          >
            View
          </Button>

          {validarpermiso("grupos", "delete", permisos) && (
            <Button type="link" danger onClick={() => DeleteGroup(record.id)}>
              Delete
            </Button>
          )}
        </Space>
      ),
    },
  ];

  const EditGroup = async (values) => {
    const directus = await getDirectusClient();
    const update = await directus.request(
      updateItem("grupos", filter.id, {
        nombre: values.nombre,
        codebar: values.codebar,
        iccid: values.iccid,
        codebarmax: values.codebarmax,
        codebarmin: values.codebarmin,
        iccidmax: values.iccid ? values.iccidmax : 0,
        iccidmin: values.iccid ? values.iccidmin : 0,
        impuesto: values.impuesto,
        afectainventario: values.afectainventario,
      })
    );
    if (update.id > 0) {
      message.success("Grupo Editado");
      GetGroups();
    } else {
      message.error("Upss!!, algo salio mal :(");
    }
  };

  return (
    <Layouts>
      <Table
        dataSource={validarpermiso("grupos", "read", permisos) ? data : []}
        columns={columns}
        title={() => (
          validarpermiso("grupos", "create", permisos) && (
            <Button icon={<PlusOutlined />} onClick={Modalopen}>
              Agregar Grupo
            </Button>
          )
        )}
      />
      <Modal
        title="Ver detalles del grupo"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        {groupselect && (
          <div>
            <p>Nombre: {groupselect.nombre}</p>
            <p>Serial?: {groupselect.codebar ? "si" : "no"}</p>
            {groupselect.codebar ? (
              <>
                <p>Serial maximo: {groupselect.codebarmax}</p>
                <p>Serial minimo: {groupselect.codebarmin}</p>
              </>
            ) : null}

            <p>ICCID?: {groupselect.iccid ? "si" : "no"}</p>
            {groupselect.iccid ? (
              <>
                <p>ICCID maximo: {groupselect.iccidmax}</p>
                <p>ICCID minimo: {groupselect.iccidmin}</p>
              </>
            ) : null}

            <p>Impuesto: {groupselect.impuesto}</p>
            <p>Estado: {groupselect.estado}</p>
            <p>
              Afecta inventario?: {groupselect.afectainventario ? "si" : "no"}
            </p>

            {/* Add more details as needed */}
          </div>
        )}
      </Modal>
      <Modal 
        open={OpenEdit && validarpermiso("grupos", "update", permisos)} 
        footer={null} 
        onCancel={handleCancel} 
        width={800}
      >
        <Form
          form={form}
          name="basic"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          autoComplete="off"
          onFinish={EditGroup}
        >
          <Row gutter={16}>
            {/* Columna Izquierda */}
            <Col span={12}>
              <Form.Item
                name="nombre"
                label="Nombre del grupo"
                rules={[
                  { required: true, message: "Este campo es obligatorio" },
                ]}
              >
                <Input placeholder="Nombre del grupo" />
              </Form.Item>

              <Form.Item
                name="impuesto"
                label="Impuesto"
                rules={[
                  { required: true, message: "Este es un campo obligatorio" },
                ]}
              >
                <InputNumber
                  min={0}
                  max={100}
                  step={0.01}
                  formatter={
                    (value) => `${value}%` // Agrega el símbolo de porcentaje después del número ingresado
                  }
                />
              </Form.Item>

              <Form.Item name="codebar" valuePropName="checked">
                <Checkbox onChange={handleCheckboxChange}>
                  Tiene serial?
                </Checkbox>
              </Form.Item>

              {hasCode && (
                <>
                  <Form.Item
                    label="Máximo"
                    name="codebarmax"
                    rules={[
                      {
                        required: true,
                        message: "Este es un campo obligatorio",
                      },
                    ]}
                  >
                    <InputNumber
                      style={{ width: "100%" }}
                      placeholder="Código de barras máximo"
                    />
                  </Form.Item>

                  <Form.Item
                    label="Mínimo"
                    name="codebarmin"
                    rules={[
                      {
                        required: true,
                        message: "Este es un campo obligatorio",
                      },
                    ]}
                  >
                    <InputNumber
                      style={{ width: "100%" }}
                      placeholder="Código de barras mínimo"
                    />
                  </Form.Item>
                </>
              )}
            </Col>

            {/* Columna Derecha */}
            <Col span={12}>
              <Form.Item name="iccid" valuePropName="checked">
                <Checkbox onChange={handleCheckbox}>ICCID?</Checkbox>
              </Form.Item>

              {Code && (
                <>
                  <Form.Item
                    label="Máximo"
                    name="iccidmax"
                    rules={[
                      {
                        required: true,
                        message: "Este es un campo obligatorio",
                      },
                    ]}
                  >
                    <InputNumber
                      style={{ width: "100%" }}
                      placeholder="Código máximo"
                    />
                  </Form.Item>

                  <Form.Item
                    label="Minimo"
                    name="iccidmin"
                    rules={[
                      {
                        required: true,
                        message: "Este es un campo obligatorio",
                      },
                    ]}
                  >
                    <InputNumber
                      style={{ width: "100%" }}
                      placeholder="Código mínimo"
                    />
                  </Form.Item>
                </>
              )}

              <Form.Item name="estado" label="Estado">
                <Select
                  placeholder="Seleccione un estado"
                  allowClear
                  style={{ width: "100%" }}
                >
                  <Option value="activo">Activo</Option>
                  <Option value="pausado">Pausado</Option>
                  <Option value="anulado">Anulado</Option>
                  <Option value="solucionado">Solucionado</Option>
                  <Option value="vencido">Vencido</Option>
                </Select>
              </Form.Item>

              <Form.Item name="afectainventario" valuePropName="checked">
                <Checkbox>Afecta Inventario?</Checkbox>
              </Form.Item>
            </Col>
          </Row>

          {/* Botón de envío */}
          <Form.Item
            wrapperCol={{ span: 24 }}
            style={{ textAlign: "right", marginTop: 16 }}
          >
            <Button type="primary" htmlType="submit">
              Editar
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      {/* Created Form */}
      <Modal
        open={ModalOpen && validarpermiso("grupos", "create", permisos)}
        onCancel={handleCancel}
        footer={false}
        width={800}
      >
        <Form
          name="basic"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          initialValues={{
            codebar: false,
            iccid: false,
            estado: false,
            codebarmax: 0,
            codebarmin: 0,
            iccidmax: 0,
            iccidmin: 0,
          }}
          autoComplete="off"
          onFinish={onFinish}
        >
          <Row gutter={16}>
            {/* Columna 1 */}
            <Col span={12}>
              <Form.Item
                name="nombre"
                label="Nombre del grupo"
                rules={[
                  { required: true, message: "Este campo es obligatorio" },
                ]}
              >
                <Input placeholder="Nombre del grupo" />
              </Form.Item>

              <Form.Item
                name="impuesto"
                label="Impuesto"
                rules={[
                  { required: true, message: "Este es un campo obligatorio" },
                  { type: "number", message: "Ingrese un número válido" },
                ]}
              >
                <InputNumber
                  min={0}
                  max={100}
                  step={0.01}
                  style={{ width: "100%" }}
                  formatter={(value) => `${value}%`}
                />
              </Form.Item>

              <Form.Item name="codebar" valuePropName="checked">
                <Checkbox onChange={handleCheckboxChange}>
                  Tiene código?
                </Checkbox>
              </Form.Item>

              {hasCode && (
                <>
                  <Form.Item
                    label="Maximo"
                    name="codebarmax"
                    rules={[
                      {
                        required: true,
                        message: "Este es un campo obligatorio",
                      },
                    ]}
                  >
                    <InputNumber style={{ width: "100%" }} />
                  </Form.Item>

                  <Form.Item
                    label="Minimo"
                    name="codebarmin"
                    rules={[
                      {
                        required: true,
                        message: "Este es un campo obligatorio",
                      },
                    ]}
                  >
                    <InputNumber style={{ width: "100%" }} />
                  </Form.Item>
                </>
              )}
            </Col>

            {/* Columna 2 */}
            <Col span={12}>
              <Form.Item name="iccid" valuePropName="checked">
                <Checkbox onChange={handleCheckbox}>ICCID?</Checkbox>
              </Form.Item>

              {Code && (
                <>
                  <Form.Item
                    label="Maximo"
                    name="iccidmax"
                    rules={[
                      {
                        required: true,
                        message: "Este es un campo obligatorio",
                      },
                    ]}
                  >
                    <InputNumber style={{ width: "100%" }} />
                  </Form.Item>

                  <Form.Item
                    label="Minimo"
                    name="iccidmin"
                    rules={[
                      {
                        required: true,
                        message: "Este es un campo obligatorio",
                      },
                    ]}
                  >
                    <InputNumber style={{ width: "100%" }} />
                  </Form.Item>
                </>
              )}

              <Form.Item name="estado" label="Estado">
                <Select placeholder="Seleccione una opción" allowClear>
                  <Option value="activo">Activo</Option>
                  <Option value="pausado">Pausado</Option>
                  <Option value="anulado">Anulado</Option>
                  <Option value="solucionado">Solucionado</Option>
                  <Option value="vencido">Vencido</Option>
                </Select>
              </Form.Item>

              <Form.Item name="afectainventario" valuePropName="checked">
                <Checkbox>Afecta Inventario?</Checkbox>
              </Form.Item>
            </Col>
          </Row>

          {/* Botón de envío */}
          <Form.Item
            wrapperCol={{ span: 24 }}
            style={{ textAlign: "right", marginTop: 16 }}
          >
            <Button type="primary" htmlType="submit">
              Crear
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      {!validarpermiso("grupos", "read", permisos) && (
        <h3>No tiene permisos para ver grupos</h3>
      )}
    </Layouts>
  );
};

export default Groups;
